import { MultiRangeSliderProps } from "../multirange_slider";
import { SingleRangeSliderProps } from "../single_range_slider";
import { SliderAttributes } from "../sliders.common";
import { SliderContext } from "./slider_context";

type SliderContextValue = SliderAttributes &
  (SingleRangeSliderProps | MultiRangeSliderProps) & { sliderId: string };

export type SliderContextProviderProps = SliderContextValue;

export const SliderContextProvider = ({
  children,
  ...props
}: React.PropsWithChildren<SliderContextProviderProps>) => (
  <SliderContext.Provider value={{ ...props }}>{children}</SliderContext.Provider>
);
